import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CancelBatchParticipationBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const cancelEducationalAdvisorBatchParticipation = createAsyncThunk<
  void,
  CancelBatchParticipationBody,
  { extra: Partial<Dependencies> }
>(
  "educationalAdvisor/cancelBatchParticipation",
  async (command: CancelBatchParticipationBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.cancelParticipation(command);
  },
);
